<template>
  <m-dialog ref="previewDlg" :btnsave="false" title="PREVIEW KTA">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="12" lg="10" xl="7">
        <v-card>
          <v-card-title class="red--text">
            Mohon perhatikan preview KTA sebelum mencetak KTA
          </v-card-title>
          <v-card-text v-if="preview">
            <v-row>
              <v-col cols="12" align-end colbox>
                <p class="py-0 my-0 ml-2 font-weight-bold title primary--text">KTP</p>
                <img height="270" class="pa-2" :src="preview.ktp.origin ? preview.ktp.origin + '?rand=' + Math.random() : 'img/no-image.jpeg'" alt="avatar" />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                <p class="py-0 my-0 ml-2 font-weight-bold title primary--text">KTA TAMPAK DEPAN</p>
                <img height="250" class="pa-2" :src="preview.kta_depan ? preview.kta_depan.origin : 'img/no-image.jpeg'" alt="avatar" />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                <p class="py-0 my-0 ml-2 font-weight-bold title primary--text">KTA TAMPAK BELAKANG</p>
                <img height="250" class="pa-2" :src="preview.kta_belakang ? preview.kta_belakang.origin : 'img/no-image.jpeg'" alt="avatar" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="warga">
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn block :disabled="warga.nomer_anggota == ''" :small="$vuetify.breakpoint.smAndDown" depressed color="info" @click="cetakGambar(warga, 1)">
                    <v-icon>mdi-file-image</v-icon> KTA Depan
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn block :disabled="warga.nomer_anggota == ''" :small="$vuetify.breakpoint.smAndDown" depressed color="info" @click="cetakGambar(warga, 2)">
                    <v-icon>mdi-file-image</v-icon> KTA Belakang
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn block :disabled="warga.nomer_anggota == ''" :small="$vuetify.breakpoint.smAndDown" depressed color="warning" @click="cetakKTA(warga)">
                    <v-icon>mdi-file-pdf-box</v-icon>Cetak KTA PDF
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn
                    v-if="warga.is_sipol == 0"
                    block
                    :disabled="warga.nomer_anggota == ''"
                    :small="$vuetify.breakpoint.smAndDown"
                    depressed
                    color="success"
                    @click="setSipol(warga)"
                  >
                    <v-icon>mdi-sticker-check-outline</v-icon>Set Sipol
                  </v-btn>
                  <v-btn v-else block :disabled="warga.nomer_anggota == ''" :small="$vuetify.breakpoint.smAndDown" depressed color="error" @click="batalSipol(warga)">
                    <v-icon>mdi-sticker-minus-outline</v-icon>Batal Sipol
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn block class="white--text" :disabled="warga.nomer_anggota == ''" :small="$vuetify.breakpoint.smAndDown" depressed color="green" @click="toKTPKTA(warga)">
                    <v-icon>mdi-file</v-icon>KTP KTA
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
import { API } from "@/const";
const M_API = API + "/api";
export default {
  components: {
    VueEditor
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      warga: null,
      ktaDepan: null,
      ktaBelakang: null,
      preview: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.preview = null;
      this.warga = { ...obj };
      this.loadPreview(obj.id);
      this.$validator.reset();
      this.imageKTA(obj.id);
      this.imageKTABelakang(obj.id);
      let x = this.$refs.previewDlg.open();
      this.$validator.reset();
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },
    loadPreview(id) {
      return this.$store
        .dispatch("warga/previewKTA", id)
        .then(res => {
          this.preview = res;
        })
        .catch(e => e);
    },
    toKTPKTA(val) {
      var j = lc.getItem(TOKEN);
      var urlktpkta = `${M_API}/warga/${val.id}/cetak_gambar_ktp_kta?access_token=${j}`;
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTP KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${val.nama} <br>
        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("warga/cetakKTAKTP", urlktpkta)
            .then(() => {
              this.$info("Data berhasil dicetak");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    imageKTA(id) {
      var j = lc.getItem(TOKEN);
      var url = `${M_API}/warga/${id}/cetak_gambar_depan?access_token=${j}`;
      this.ktaDepan = url;
    },
    imageKTABelakang(id) {
      var j = lc.getItem(TOKEN);
      var url = `${M_API}/warga/${id}/cetak_gambar_belakang?access_token=${j}`;
      this.ktaBelakang = url;
    },
    cetakKTA() {
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${this.preview.nama} <br>
        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("warga/cetak", this.preview.kta_pdf.origin)
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    cetakGambar(item, jenis) {
      this.$confirm(
        `Apakah Anda yakin akan mencetak Gambar KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama} <br>
        </div>
      `
      )
        .then(() => {
          if (jenis == 1) {
            // window.open(this.preview.kta_depan.origin, "_blank");

            this.$store
              .dispatch("warga/cetakGambarDepan", this.preview.kta_depan.origin)
              .then(() => {})
              .then(() => this.load())
              .catch(e => e);
          } else {
            // window.open(this.preview.kta_belakang.origin, "_blank");

            this.$store
              .dispatch("warga/cetakGambarBelakang", this.preview.kta_belakang.origin)
              .then(() => {})
              .then(() => this.load())
              .catch(e => e);
          }
        })
        .catch(e => e);
    },
    setSipol() {
      this.$confirm(
        `Apakah Anda yakin akan menentukan warga ini sebagai SIPOL ?<br>
        <div class="mt-2 title grow text-center">
           ${this.preview.nama} <br>
        </div>
      `
      )
        .then(() => {
          this.$store
            .dispatch("warga/setsipol", { obj: this.warga, value: true })
            .then(() => {
              this.$info("Data berhasil diset SIPOL");
              this.$refs.previewDlg.resolve();
            })
            .catch(e => e);
        })
        .catch(e => e);
    },
    batalSipol() {
      this.$confirm(
        `Apakah Anda yakin akan membatalkan warga ini sebagai SIPOL ?<br>
        <div class="mt-2 title grow text-center">
           ${this.preview.nama} <br>
        </div>
      `
      )
        .then(() => {
          this.$store
            .dispatch("warga/setsipol", { obj: this.warga, value: false })
            .then(() => {
              this.$info("Data berhasil diset Batal SIPOL");
              this.$refs.previewDlg.resolve();
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
